import React, { Fragment } from 'react';
import TenantView from './TenantView';

const ViewTenant = () => {
    return (
        <TenantView />
    );
}

export default ViewTenant